<template>
    <div class="dokan-logical-container">
        <ul>
            <li class="dokan-logical-label-li">
                <span class="badge-level">{{ __( 'Level 1', 'dokan' ) }}</span>
                <div class="dokan-logical-container-div">
                    <strong class="demo-title"></strong>
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="icon icon-count"></i>
                        </span>
                        <input class="demo-input form-control" type="number" name="amount" disabled placeholder="-------------------">
                    </div>
                </div>
            </li>
            <li class="dokan-logical-label-li">
                <span class="badge-level">{{ __( 'Level 2', 'dokan' ) }}</span>
                <div class="dokan-logical-container-div">
                    <strong class="demo-title"></strong>
                    <div class="input-group">
                        <span class="input-group-text">
                            <i class="icon icon-count"></i>
                        </span>
                        <input class="demo-input form-control" type="number" name="amount" disabled placeholder="-------------------">
                    </div>
                    <i class="remove-level" :title="__('Remove badge level', 'dokan')"></i>
                </div>
            </li>
        </ul>
        <div>
            <button @click.prevent="addLevel" disabled class="button button-secondary">+ {{ __('Add', 'dokan') }}</button>
        </div>
    </div>
</template>

<script>
import defaultBadgeLevelData from '../../../BadgeLevel.json';

export default {
    name: 'DummyLevels',

    props: {
        event: {
            type: Object,
            default () {
                return this.getLevels();
            },
        },
    },

    inject: ['setBadgeLevels', 'getBadgeLevels'],

    data () {
        return {
            badge_levels: this.getLevels(),
        }
    },

    created () {
        this.$watch('badge_levels', (newLevels) => {
            this.setBadgeLevels( this.badge_levels );
        });
    },

    activated() {
        // keep-alive
        // called on initial mount
        // and every time it is re-inserted from the cache
        this.setBadgeLevels( this.badge_levels );
    },

    deactivated() {
        // keep-alive
        // called when removed from the DOM into the cache
        // and also when unmounted
    },

    methods: {
        getLevels() {
            if ( ! this.getBadgeLevels().length ) {
                return this.getDefaultBadgeLevels();
            }
            return this.getBadgeLevels();
        },

        getDefaultBadgeLevels() {
            defaultBadgeLevelData.level_condition = '';
            defaultBadgeLevelData.level_data = 0;
            return [
                Object.assign({}, defaultBadgeLevelData),
            ]
        },
    }
};
</script>

<style lang="less" scoped>
.dokan-logical-container {
    .dokan-logical-label-li {
        margin-bottom: 20px;
    }

    .badge-level {
        background: #B9B9B9;
        border-radius: 1rem;
        padding: 0.3rem 1rem;
        vertical-align: middle;
        display: inline-block;
        margin-bottom: 1rem;
        line-height: 16px;
        letter-spacing: 0.08px;
        color: #FFFFFF;
        font-size: 0.75rem;
        font-weight: 600;
    }

    .remove-level {
        background: url('../../../../images/others/close.svg');
        width: 14px;
        height: 14px;
        line-height: 17px;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
    }

    .dokan-logical-container-div {
        display: flex;
        justify-content: flex-start;
        flex-flow: row wrap;
        align-items: center;
        gap: 20px;

        @media (max-width:767px) {
            flex-direction: column;
            align-items: stretch;
            margin-bottom: 40px;
        }

        .demo-title {
            flex-basis: 25%;
            border: 2px dashed #808080;
            border-top: 0;
            height: 1px;
            border-left: 0;
            border-right: 0;
            margin-right: 26px;

            @media (max-width:767px) {
                margin-right: 0;
            }
        }

        .demo-input {
            flex-basis: 45%;

            &::placeholder {
                width: 95%;
                height: 2px;
                background: #E2E2E2;
                position: relative;
                top: 7.5px;
                left: 9px;
            }
        }

    }
}
</style>
